import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import MyPartyResponse from "./responses/apiResponses";
import { ApiResponse, handleAxiosError } from "./responses/AxiosResponseHandler";
import { parseMyPartyResponse } from "./parseResponse/parseMyPartiesResponse";
import { PartyModel } from "../types";

class GroupsClient {
  private authClient: AuthClient;

  constructor(authClient: AuthClient) {
    this.authClient = authClient;
  }

  public async getMyParties(): Promise<ApiResponse<PartyModel[]> | undefined> {
    try {

      const response = await axios.get(
        `${this.authClient.getApiRoot()}/groups/myparties`,
        {
          headers: {
            Authorization: `Bearer ${this.authClient.getAuthenticationResponse()?.token}`,
          },
        }
      );

      return {
        statusCode: response.status,
        errorMessage: "",
        data: (response.data as MyPartyResponse[]).map(parseMyPartyResponse),
      };
    } catch (error) {
      const errorResponse = handleAxiosError<PartyModel[]>(
        error as AxiosError
      );
      return {
        statusCode: errorResponse.statusCode,
        errorMessage: errorResponse.errorMessage,
        data: errorResponse.data,
      };
    }
  }

  public async getMyPartyById(id: string): Promise<ApiResponse<PartyModel> | undefined> {
    try {
      const response = await axios.get(
        `${this.authClient.getApiRoot()}/groups/myparties/${id}`,
        {
          headers: {
            Authorization: `Bearer ${this.authClient.getAuthenticationResponse()?.token}`,
          },
        }
      );

      return {
        statusCode: response.status,
        errorMessage: "",
        data: parseMyPartyResponse(response.data as MyPartyResponse),
      };
    } catch (error) {
      const errorResponse = handleAxiosError<PartyModel>(
        error as AxiosError
      );
      return {
        statusCode: errorResponse.statusCode,
        errorMessage: errorResponse.errorMessage,
        data: errorResponse.data,
      };
    }
  }

  public async getParsedMyParties(): Promise<ApiResponse<PartyModel[]> | undefined> {
    return this.getMyParties();
  }

  public async getParsedMyPartyById(id: string): Promise<ApiResponse<PartyModel> | undefined> {
    return this.getMyPartyById(id);
  }
}

export default GroupsClient;
